export default "__VITE_ASSET__5643930d__"